import services from '../services/axios-services';
import serviceConfig, { IServiceConfig } from '../services/servicesConfig';
import { Dispatch } from 'redux';
import commonStore from '../store/commonStore.js';
import * as deviceInfoService from '../utils/general/deviceInfoService';
import { serviceInjectScript } from '../utils/general/customService';
import { presentationHTMLFragments, presentationJSONFragments } from '../actions/presentationStateAction';
import { get, isEmpty, merge, split } from 'lodash';
import $ from 'jquery';
import { isStaticMode, storeDeviceIdInEvercookie } from '../utils/general/general';
import * as commonStateAction from '../actions/commonStateAction';
import { Base64 } from 'js-base64';
import moment from "moment";
import RenditionUrlGenerator from '../utils/api/renditionUrlGenerator';
import clickThruJson from '../../data/Clickthru.json'
import * as HTML_RENDITION from '../utils/general/general';
import {SubscribeResult} from '../../js/states/renditionStates';

export interface IAsyncStateAction {
    type: string;
    value: any;
    originDocId?: any;
    pollId: number;
}

export const requestInitialData = () => ({
    type: 'REQUEST_INITIAL_DATA',
});

export const receiveInitialData = (data: any) => ({
    type: 'RECEIVE_INITIAL_DATA',
    value: data,
});

export const requestHeaderJsonData = () => ({
    type: 'REQUEST_HEADER_JSON_DATA',
});

export const receiveHeaderJsonData = (data: any) => ({
    type: 'RECEIVE_HEADER_JSON_DATA',
    value: data,
});

export const requestFooterJsonData = () => ({
    type: 'REQUEST_FOOTER_JSON_DATA',
});

export const receiveFooterJsonData = (data: any) => ({
    type: 'RECEIVE_FOOTER_JSON_DATA',
    value: data,
});

export const requestAnalystSubscriptionData = () => ({
    type: 'REQUEST_ANALYST_SUBSCRIPTION_DATA',
});

export const receiveAnalystSubscriptionData = (data: any) => ({
    type: 'RECEIVE_ANALYST_SUBSCRIPTION_DATA',
    value: data,
});

export const requestSubscribeAuthorBySoeid = () => ({
    type: 'REQUEST_SUBSCRIBE_AUTHOR_BY_SOEID',
});

export const receiveSubscribeAuthorBySoeid = (data: SubscribeResult) => ({
    type: 'RECEIVE_SUBSCRIBE_AUTHOR_BY_SOEID',
    value: data,
});

export const requestEconomicCalendarJsonData = () => ({
    type: 'REQUEST_ECONOMIC_CALENDAR_JSON_DATA',
});

export const receiveEconomicCalendarJsonData = (data: any) => ({
    type: 'RECEIVE_ECONOMIC_CALENDAR_JSON_DATA',
    value: data,
});

export const requestEventCalendarJsonData = () => ({
    type: 'REQUEST_EVENT_CALENDAR_JSON_DATA',
});

export const receiveEventCalendarJsonData = (data: any) => ({
    type: 'RECEIVE_EVENT_CALENDAR_JSON_DATA',
    value: data,
});

export const requestBodyJsonData = () => ({
    type: 'REQUEST_BODY_JSON_DATA',
});

export const requestClickThruJsonData = () => ({
    type: 'REQUEST_CLICKTHRU_JSON_DATA',
});

export const receiveBodyJsonData = (data: any) => ({
    type: 'RECEIVE_BODY_JSON_DATA',
    value: data,
});

export const receiveClickThruJsonData = (data: any) => ({
    type: 'RECEIVE_CLICKTHRU_JSON_DATA',
    value: data,
});

export const requestBodyJsonDataOnebyOne = () => ({
    type: 'REQUEST_BODY_JSON_DATA_ONE_BY_ONE',
});

export const receiveBodyJsonDataOnebyOne = (data: any) => ({
    type: 'RECEIVE_BODY_JSON_DATA_ONE_BY_ONE',
    value: data,
});

export const requestFlipVerisonDoc = () => ({
    type: 'REQUEST_FLIP_VERISON_DOC',
});

export const receiveFlipVerisonDoc = (data: any) => ({
    type: 'RECEIVE_FLIP_VERISON_DOC',
    value: data,
});

export const requestOriginFlipVerisonDoc = () => ({
    type: 'REQUEST_ORIGIN_FLIP_VERISON_DOC',
});

export const receiveOriginFlipVerisonDoc = (data: any, _originDocId: any) => ({
    type: 'RECEIVE_ORIGIN_FLIP_VERISON_DOC',
    value: data,
    originDocId: _originDocId,
});

export const requestMultiCompanySection = () => ({
    type: 'REQUEST_MULTI_COMPANY_SECTION',
});

export const receiveMultiCompanySection = (data: any) => ({
    type: 'RECEIVE_MULTI_COMPANY_SECTION',
    value: data,
});

export const requestCopyURL = () => ({
    type: 'REQUEST_COPY_URL',
});

export const receiveCopyURL = (data: any) => ({
    type: 'RECEIVE_COPY_URL',
    value: data,
});

export const requestCopyFigureURL = () => ({
    type: 'REQUEST_COPY_FIGURE_URL',
});

export const receiveCopyFigureURL = (data: any) => ({
    type: 'RECEIVE_COPY_FIGURE_URL',
    value: data,
});

export const requestCVMenuData = () => ({
    type: 'REQUEST_CV_MENU_DATA',
});

export const receiveCVMenuData = (data: any) => ({
    type: 'RECEIVE_CV_MENU_DATA',
    value: data,
});

export const requestAllCampaignsData = () => ({
    type: 'REQUEST_ALL_CAMPAIGNS_DATA',
});

export const receiveAllCampaignsData = (data: any) => ({
    type: 'RECEIVE_ALL_CAMPAIGNS_DATA',
    value: data,
});

export const requestEventsData = () => ({
    type: 'REQUEST_EVENTS_DATA',
});

export const receiveEventsData = (data: any) => ({
    type: 'RECEIVE_EVENTS_DATA',
    value: data,
});

export const requestStacksData = (datatype: string) => ({
    type: 'REQUEST_STACKS_' + datatype + '_DATA',
});

export const receiveStacksData = (data: any, datatype: string) => ({
    type: 'RECEIVE_STACKS_' + datatype + '_DATA',
    value: data,
});

export const requestStyleFactorsData = () => ({
    type: 'REQUEST_STYLE_FACTORS_DATA',
});

export const receiveStyleFactorsData = (data: any) => ({
    type: 'RECEIVE_STYLE_FACTORS_DATA',
    value: data,
});

export const requestRestrictionDetailsData = () => ({
    type: 'REQUEST_RESTRICTION_DETAILS_DATA',
});

export const receiveRestrictionDetailsData = (data: any) => ({
    type: 'RECEIVE_RESTRICTION_DETAILS_DATA',
    value: data,
});

export const requestReportingCalendarData = () => ({
    type: 'REQUEST_REPORTING_CALENDAR_DATA',
});

export const receiveReportingCalendarData = (data: any) => ({
    type: 'RECEIVE_REPORTING_CALENDAR_DATA',
    value: data,
});

export const requestCatalystWatchData = () => ({
    type: 'REQUEST_CATALYST_WATCH_DATA',
});

export const receiveCatalystWatchData = (data: any) => ({
    type: 'RECEIVE_CATALYST_WATCH_DATA',
    value: data,
});

export const requestCrmUserDetailsData = () => ({
    type: 'REQUEST_CRM_USER_DETAILS_DATA',
});

export const receiveCrmUserDetailsData = (data: any) => ({
    type: 'RECEIVE_CRM_USER_DETAILS_DATA',
    value: data,
});

export const requestMailData = () => ({
    type: 'REQUEST_MAIL_DATA',
});

export const receiveMailData = (data: any) => ({
    type: 'RECEIVE_MAIL_DATA',
    value: data,
});

export const requestFPFigureGalleryData = () => ({
    type: 'REQUEST_FP_FIGURE_GALLERY_DATA',
});

export const receiveFPFigureGalleryData = (data: any) => ({
    type: 'RECEIVE_FP_FIGURE_GALLERY_DATA',
    value: data,
});

export const requestFigureGalleryData = () => ({
    type: 'REQUEST_FIGURE_GALLERY_DATA',
});

export const receiveFigureGalleryData = (data: any) => ({
    type: 'RECEIVE_FIGURE_GALLERY_DATA',
    value: data,
});

export const requestForecastData = () => ({
    type: 'REQUEST_FORECAST_DATA',
});

export const receiveForecastData = (data: any, forecastType: string) => ({
    type: 'RECEIVE_FORECAST_DATA',
    value: { data, forecastType },
});

export const requestFinSumData = () => ({
    type: 'REQUEST_FINSUM_DATA',
});

export const receiveFinSumData = (data: any) => ({
    type: 'RECEIVE_FINSUM_DATA',
    value: data,
});

export const receiveFinSumError = () => ({
    type: 'RECEIVE_FINSUM_ERROR',
});

export const requestFocusList = () => ({
    type: 'REQUEST_FOCUS_LIST',
});

export const receiveFocusList = (data: any) => ({
    type: 'RECEIVE_FOCUS_LIST',
    value: data
});

export const requestRelatedPublications = () => ({
    type: 'REQUEST_RELATED_PUBLICATIONS',
});

export const receiveRelatedPublications = (data: any) => ({
    type: 'RECEIVE_RELATED_PUBLICATIONS',
    value: data
});

export const requestPriceChartData = () => ({
    type: 'REQUEST_PRICECHART_DATA',
});

export const receivePriceChartData = (data: any) => ({
    type: 'RECEIVE_PRICECHART_DATA',
    value: data,
});

export const requestReportsToRevisitData = () => ({
    type: 'REQUEST_REPORTS_TO_REVISIT_DATA',
});

export const requestBookMeetingData = () => ({
    type: 'REQUEST_BOOK_MEETING_DATA',
});
export const receiveBookMeetingData = (data: any) => ({
    type: 'RECEIVE_BOOK_MEETING_DATA',
    value: data,
});

export const receiveReportsToRevisitData = (data: any) => ({
    type: 'RECEIVE_REPORTS_TO_REVISIT_DATA',
    value: data,
});

export const requestcvMacroToolsData = () => ({
    type: 'REQUEST_CV_MACRO_TOOLS_DATA',
});

export const receivecvMacroToolsData = (data: any) => ({
    type: 'RECEIVE_CV_MACRO_TOOLS_DATA',
    value: data,
});

export const requestThemesData = () => ({
    type: 'REQUEST_THEMES_DATA',
});

export const receiveThemesData = (data: any) => ({
    type: 'RECEIVE_THEMES_DATA',
    value: data,
});

export const requestESGTableData = () => ({
    type: 'REQUEST_ESG_TABLE_DATA',
});

export const receiveESGTableData = (data: any) => ({
    type: 'RECEIVE_ESG_TABLE_DATA',
    value: data,
});

export const requestAnalystInfoById = () => ({
    type: 'REQUEST_ANALYST_INFO_BY_ID',
});

export const receiveAnalystInfoById = (data: any) => ({
    type: 'RECEIVE_ANALYST_INFO_BY_ID',
    value: data,
});

export const requestAnalystInfoByName = () => ({
    type: 'REQUEST_ANALYST_INFO_BY_NAME',
});

export const receiveAnalystInfoByName = (data: any) => ({
    type: 'RECEIVE_ANALYST_INFO_BY_NAME',
    value: data,
});

export const requestPollResults = () => ({
    type: 'REQUEST_POLL_DATA',
});

export const receivePollResults = (data: any, _pollId: number) => ({
    type: 'RECEIVE_POLL_DATA',
    value: data,
    pollId: _pollId
});

export const requestRelatedReportData = () => ({
    type: 'REQUEST_RELATED_REPORT_DATA',
});

export const receiveRelatedReportData = (data: any) => ({
    type: 'RECEIVE_RELATED_REPORT_DATA',
    value: data,
});

export const requestRegionBarData = () => ({
    type: 'REQUEST_REGION_BAR_DATA',
});

export const receiveRegionBarData = (data: any) => ({
    type: 'RECEIVE_REGION_BAR_DATA',
    value: { data },
});

export const requestFlagshipPeriodicalData = () => ({
    type: 'REQUEST_FLAGSHIP_PERIODICAL_DATA',
});

export const receiveFlagshipPeriodicalData = (data: any) => ({
    type: 'RECEIVE_FLAGSHIP_PERIODICAL_DATA',
    value: { data },
});

export const requestPresentationHTMLData = () => ({
    type: 'REQUEST_PRESENTATION_HTML_DATA',
});

export const receivePresentationHTMLData = (data: any) => ({
    type: 'RECEIVE_PRESENTATION_HTML_DATA',
    value: data,
});

export const requestPresentationJSONData = () => ({
    type: 'REQUEST_PRESENTATION_JSON_DATA',
});

export const receivePresentationJSONData = (data: any) => ({
    type: 'RECEIVE_PRESENTATION_JSON_DATA',
    value: data,
});

export const requestGlobalMarketData = () => ({
    type: 'REQUEST_GLOBAL_MARKET_DATA',
});

export const receiveGlobalMarketData = (data: any) => ({
    type: 'RECEIVE_GLOBAL_MARKET_DATA',
    value: { data },
});

export const requestKeyDataChangeData = () => ({
    type: 'REQUEST_KEY_DATA_CHANGE_DATA',
});

export const receiveKeyDataChangeData = (data: any) => ({
    type: 'RECEIVE_KEY_DATA_CHANGE_DATA',
    value: { data },
});

export const requestMustReadSectionData = () => ({
    type: 'REQUEST_MUST_READ_SECTION_DATA',
});

export const receiveMustReadSectionData = (data: any) => ({
    type: 'RECEIVE_MUST_READ_SECTION_DATA',
    value: data,
});

export const requestFileUrlPath = () => ({
    type: 'REQUEST_FILE_URL_PATH'
});

export const receiveFileUrlPath = (data: any) => ({
    type: 'RECEIVE_FILE_URL_PATH',
    value: data
});

export const requestSendEmail = () => ({
    type: 'REQUEST_SEND_EMAIL',
});

export const receiveSendEmail = (data: any) => ({
    type: 'RECEIVE_SEND_EMAIL',
    value: data
});

export const requestAnalystModel = () => ({
    type: 'REQUEST_ANALYST_MODEL',
});

export const receiveAnalystModel = (data: any) => ({
    type: 'RECEIVE_ANALYST_MODEL',
    value: data
});
export const requestCompanyCoverageByTicker = () => ({
    type: 'REQUEST_COMPANY_COVERAGE_BY_TICKER',
});
export const receiveCompanyCoverageByTicker = (data: any) => ({
    type: 'RECEIVE_COMPANY_COVERAGE_BY_TICKER',
    value: data
});
export const receiveCompanyCoverageByCode = (data: any) => ({
    type: 'RECEIVE_COMPANY_COVERAGE_BY_CODE',
    value: data
});
export const requestUserEntitlements = () => ({
    type: 'REQUEST_USER_ENTITLEMENTS',
});
export const receiveUserEntitlements = (data: any) => ({
    type: 'RECEIVE_USER_ENTITLEMENTS',
    value: data
});
export const requestCampaignsData= () => ({
    type: 'REQUEST_CAMPAIGNS_DATA',
});
export const receiveCampaignsData = (data: any) => ({
    type: 'RECEIVE_CAMPAIGNS_DATA',
    value: data
});
export const receiveExpectedPerformance = (data: any) => ({
    type: 'RECEIVE_EXPECTED_PERFORMANCE',
    value: data
});
export const updateAnalystModelLoader = (data: any) => ({
    type: 'UPDATE_ANALYST_MODEL_LOADER',
    value: data
});
export const sendEmailError = (data: any) => ({
    type: 'UPDATE_SEND_EMAIL_ERROR',
    value: data
});

export const fetchData = () => (dispatch: Dispatch) => {
    dispatch(requestInitialData());
    if (!(window.HTML_RENDITION.devEnvironment && isEmpty(window.HTML_RENDITION.initialData))) {
        dispatch(receiveInitialData(window.HTML_RENDITION.initialData));
    }
};

export const requestSessionContextData = () => ({
    type: 'REQUEST_SESSION_CONTEXT_DATA',
});

export const receiveSessionContextData = (data: any) => ({
    type: 'RECEIVE_SESSION_CONTEXT_DATA',
    value: { data },
});

export const requestPlatformIdData = () => ({
    type: 'REQUEST_PLATFORM_ID_DATA',
});

export const receivePlatformIdData = (data: any) => ({
    type: 'RECEIVE_PLATFORM_ID_DATA',
    value: data ,
});

export const requestExcludeCopyFigurePlatformIdData = () => ({
    type: 'REQUEST_EXCLUDE_COPY_FIGURE_PLATFORM_ID_DATA',
});

export const receiveExcludeCopyFigurePlatformIdData = (data: any) => ({
    type: 'RECEIVE_EXCLUDE_COPY_FIGURE_PLATFORM_ID_DATA',
    value: data ,
});

const doAjaxGetSplitHeaderSection = (urlDetail: IServiceConfig, index: number, headerSectionSplitFilename: string) => {
    urlDetail.url_tokens[index] = headerSectionSplitFilename;
    return new Promise((resolve, reject) => {
        services.getData(urlDetail, {}, '')
        .then((response: any) => {
            let jsonObj = response.data;
            if (typeof response.data == 'string') {
                jsonObj = JSON.parse(response.data);
            }
            resolve(jsonObj);
        }).catch((error: any) => {
            console.error(error);
            reject(error);
        });
      });
};

export const fetchHeaderData = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestHeaderJsonData());
    let gotData = false;

    const headerFileCount =  window.HTML_RENDITION.initialData.header_file_count || 0;
    if (headerFileCount > 1) {
        const jsonFilename = window.HTML_RENDITION.initialData.header_file_name + '.json';
        const index = urlDetail.url_tokens.indexOf(jsonFilename);
        if (index === -1) {
            throw new Error('Failure at getting jsonFilename from urlDetail.');
        }
        const _promiseArray: any = [];
        let headerFileJson: any = {};
        for (let i = 0; i < headerFileCount; i++) {
            _promiseArray.push(doAjaxGetSplitHeaderSection(urlDetail, index, `${window.HTML_RENDITION.initialData.header_file_name}_${i}.json`));
        }
        try {
            Promise.all(_promiseArray)
                .then( (results) => {
                    const _results: any = results;
                    for (const key in _results) {
                        if (_results.hasOwnProperty(key)) {
                            headerFileJson = merge(headerFileJson,  _results[key]);
                        }
                    }
                    if (isEmpty(headerFileJson)) {
                        throw new Error('Failure at getting split header_section with empty.');
                    }
                    dispatch(receiveHeaderJsonData(headerFileJson));
                    if (headerFileJson.isEquationPresent) {
                        $('html, body').addClass('equation-doc');
                        serviceInjectScript('https://cdn.mathjax.org/mathjax/latest/MathJax.js?config=TeX-AMS-MML_HTMLorMML', false, false);
                    }
                    gotData = true;
                    return;
                }).catch((error) => {
                    console.error(error);
                    gotData = false;
                    throw new Error('Failure at getting split header_section.');
                });
        } catch (e){
            console.error(e);
            gotData = false;
            throw new Error('Failure at getting split header_section.');
        }
        return;
    } else if (window.HTML_RENDITION.initialData.blogListPageRequiredData){
        try {
            dispatch(receiveHeaderJsonData(JSON.parse(Base64.decode(window.HTML_RENDITION.initialData.blogListPageRequiredData))));
            gotData = true;
        } catch (e){
            console.error(e);
            gotData = false;
        }
    } else if (window.HTML_RENDITION.initialData.blogHeaderData){
         try {
             dispatch(receiveHeaderJsonData(JSON.parse(Base64.decode(window.HTML_RENDITION.initialData.blogHeaderData))));
             gotData = true;
         } catch (e){
             console.error(e);
             gotData = false;
         }
     }
    if (!gotData) {
        return new Promise((resolve, reject) => {
            services.getData(urlDetail, {}, '')
                .then((response: any) => {
                    dispatch(receiveHeaderJsonData(response.data));
                    if (response.data.isEquationPresent) {
                        $('html, body').addClass('equation-doc');
                        serviceInjectScript('https://cdn.mathjax.org/mathjax/latest/MathJax.js?config=TeX-AMS-MML_HTMLorMML', false, false);
                    }
                    resolve(response.data);
                }).catch((error: any) => {
                    console.error(error);
                    reject(error);
                });
        });
    }
};

export const fetchFooterData = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestFooterJsonData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveFooterJsonData(response.data)))
        .catch((error: any) => {
            dispatch(receiveFooterJsonData({}));
            console.error(error);
        });
};

export const fetchEconomicCalendarData = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestEconomicCalendarJsonData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveEconomicCalendarJsonData(response.data)))
        .catch((error: any) => {
            dispatch(receiveEconomicCalendarJsonData({}));
            console.error(error);
        });
};

export const fetchEventCalendarData = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestEventCalendarJsonData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveEventCalendarJsonData(response.data)))
        .catch((error: any) => {
            dispatch(receiveEventCalendarJsonData({}));
            console.error(error);
        });
};

export const fetchBodyData = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestBodyJsonData());
    let gotData = false;
    if (window.HTML_RENDITION.initialData.blogBodyData){
        try {
            dispatch(receiveBodyJsonData(JSON.parse(Base64.decode(window.HTML_RENDITION.initialData.blogBodyData))));
            gotData = true;
        } catch (e){
            console.error(e);
            gotData = false;
        }
    }
    if (!gotData){
        services.getData(urlDetail, {}, '')
            .then((response: any) => {
                dispatch(receiveBodyJsonData(response.data));
                if (isStaticMode()) {
                    import('../regulatory/static-page').then(({ default: startStaticPage }) => {
                        setTimeout(() => startStaticPage(), 500);
                    });
                }
            })
            .catch((error: any) => {
                console.error(error); throw error;
            });
    }
};

export const fetchHTMLSlideData = (urlDetail: IServiceConfig, fileName: string, index: string) => (dispatch: Dispatch) => {
    const modalStatus = commonStore.getState().presentationStateReducer.modalStatus;
    urlDetail.url_tokens[urlDetail.url_tokens.length - 1] = fileName;
    dispatch(requestPresentationHTMLData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => {
            dispatch(receivePresentationHTMLData(response.data));
            dispatch(presentationHTMLFragments(index, response.data));
        }).catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchJSONSlideData = (urlDetail: IServiceConfig, fileName: string, index: string) => (dispatch: Dispatch) => {
    urlDetail.url_tokens[urlDetail.url_tokens.length - 1] = fileName;
    dispatch(requestPresentationJSONData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => {
            dispatch(receivePresentationJSONData(response.data));
            dispatch(presentationJSONFragments(index, response.data));
        }).catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchClickThruData = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(receiveClickThruJsonData(clickThruJson))
};

export const fetchCVMenuData = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestCVMenuData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveCVMenuData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchCampaignsData = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    const params = [];
    const docHeaderJsonData = commonStore.getState().asyncStateReducer.docHeaderJsonData;
    if (docHeaderJsonData.issuerPage.tags && docHeaderJsonData.issuerPage.tags.tagsByDCCode) {
        params.push("SECTOR=" + docHeaderJsonData.issuerPage.tags.tagsByDCCode.SECTOR);
        params.push("ASSETTYPE=" + docHeaderJsonData.issuerPage.tags.tagsByDCCode.ASSETTYPE);
        params.push("REGION=" + docHeaderJsonData.issuerPage.tags.tagsByDCCode.REGION);
    }
    if (docHeaderJsonData.issuerPage.tags && docHeaderJsonData.issuerPage.tags.tagsByDCCodeName) {
        params.push("ASSETTYPE_NAME=" + docHeaderJsonData.issuerPage.tags.tagsByDCCodeName.ASSETTYPE);
    }
    params.push('rendition_doc_id=' + commonStore.getState().asyncStateReducer.initialData.doc_id);
    urlDetail.url_parameter = params;

    dispatch(requestCampaignsData());

    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveCampaignsData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchEventsData = (urlDetail: IServiceConfig, data: any) => (dispatch: Dispatch) => {
    dispatch(requestEventsData());
    services.getData(urlDetail, data, '')
        .then((response: any) => dispatch(receiveEventsData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchStacksData = (urlDetail: IServiceConfig, datatype: string) => (dispatch: Dispatch) => {
    const properties: Array<string> = [];
    dispatch(requestStacksData(datatype));
    switch (datatype) {
        case 'RELATEDRESEARCH':
            properties.push('docIds=' + commonStore.getState().asyncStateReducer.initialData.doc_id);
            properties.push('serviceType=relatedResearch');
            break;
        case 'TRENDING':
            properties.push('platformId=' + window.HTML_RENDITION.initialData.platform);
            properties.push('serviceType=trending');
            properties.push('rendition_doc_id=' + commonStore.getState().asyncStateReducer.initialData.doc_id);
            properties.push('requestId=' + encodeURIComponent(commonStore.getState().asyncStateReducer.initialData.requestid));
            break;
        case 'REC':
            properties.push('count=3');
            properties.push('serviceType=rec');
            properties.push('rendition_doc_id=' + commonStore.getState().asyncStateReducer.initialData.doc_id);
            properties.push('requestId=' + encodeURIComponent(commonStore.getState().asyncStateReducer.initialData.requestid));
            break;
        case 'POP':
            properties.push('count=3');
            properties.push('serviceType=pop');
            properties.push('rendition_doc_id=' + commonStore.getState().asyncStateReducer.initialData.doc_id);
            break;
        case 'MORE_REC':
            properties.push('count=20');
            properties.push('serviceType=rec');
            properties.push('fetchAllFields=Y');
            properties.push('rendition_doc_id=' + commonStore.getState().asyncStateReducer.initialData.doc_id);
            properties.push('requestId=' + encodeURIComponent(commonStore.getState().asyncStateReducer.initialData.requestid));
            break;
        case 'MORE_POP':
            properties.push('count=50');
            properties.push('fetchAllFields=Y');
            properties.push('serviceType=pop');
            properties.push('rendition_doc_id=' + commonStore.getState().asyncStateReducer.initialData.doc_id);
            break;
        default:
            return;
    }
    urlDetail.url_parameter = properties;
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveStacksData(response.data, datatype)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchReportingCalendarData = (urlDetail: IServiceConfig, data: any) => (dispatch: Dispatch) => {
    const properties: Array<string> = [];
    dispatch(requestReportingCalendarData());
    urlDetail.url_parameter = properties;
    // urlDetail.method = 'POST';
    services.getData(urlDetail, (data), '')
        .then((response: any) => dispatch(receiveReportingCalendarData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });

};

export const fetchBodyDataOneByOne = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    let bodyJSONCount: number = commonStore.getState().asyncStateReducer.docHeaderJsonData.totalJSONFileCount - 2;
    const hasSection: boolean = commonStore.getState().asyncStateReducer.docHeaderJsonData.hasSection;
    const productType: string = commonStore.getState().asyncStateReducer.initialData.productType;
    if (hasSection) {
        bodyJSONCount--;
    }
    let bodyJSONNO: number = 1;
    let _bodyTextJSON: any = null;
    const _promiseArray: any = [];
    let _promise: any = null;
    let bodyText: Array<any> = [];
    const getMoreData = () => {
        for (bodyJSONNO; bodyJSONNO <= bodyJSONCount; bodyJSONNO++) {
            _bodyTextJSON = 'body_section_' + bodyJSONNO + '.json';
            if (bodyJSONNO > 1) {
                urlDetail.url_tokens.pop();
            }
            urlDetail.url_tokens.push(_bodyTextJSON);
            dispatch(requestBodyJsonDataOnebyOne());
            _promise = services.getData(urlDetail, {}, '').catch((error: any) => {
                console.error(error); throw error;
            });
            _promiseArray.push(_promise);
        }
        Promise.all(_promiseArray)
            .then(function (results) {
                const _results: any = results;
                for (const key in _results) {
                    if (_results.hasOwnProperty(key)) {
                        bodyText = bodyText.concat(_results[key].data.bodyText);
                    }
                }
                // Important!!! below setInterval is to prevent very large bodyJSON doc can't open in IE
                // In multicompany,I use setInterval in fetchSectionData and trigger react-diff in setInterval
                // So more than one setInterval running and trigger react-diff at same time will cause perfomance down when the data is very large special in IE.
                // (before open below code you must test doc bodyjson length large enough that already cause long-script running warning in IE.)
                // More important is please also read DomTemplate.tsx first line comment.
                if (false && productType != "multicompany" && deviceInfoService.isIE()) {
                    const _data = bodyText;
                    const _dataLength = bodyText.length;
                    // dispatch in setInterval will cause react-diff,but we lack a valid key in DomTemplate.tsx,So set this value as more as large if possible.
                    const _distance = 300;
                    let _start = 0;
                    let _end = _distance;
                    let _partBodyJSON: any = null;
                    const _time = 1000;
                    const timeout = window.setInterval(function () {
                        _partBodyJSON = bodyText.slice(_start, _end);
                        dispatch(receiveBodyJsonDataOnebyOne(_partBodyJSON));
                        if (_end >= _dataLength) {
                            window.clearInterval(timeout);
                        } else {
                            _start = _start + _distance;
                            _end = _end + _distance;
                        }
                    }, _time);
                } else {
                    dispatch(receiveBodyJsonDataOnebyOne(bodyText));
                    commonStore.dispatch(commonStateAction.fetchBodyJsonFinished(true));
                    storeDeviceIdInEvercookie();
                }
                if (isStaticMode()) {
                    import('../regulatory/static-page').then(({ default: startStaticPage }) => {
                        setTimeout(() => startStaticPage(), 500);
                    });
                }
            }).catch((error: any) => {
                console.error(error); throw error;
            });
    };
    getMoreData();
};

export const fetchFlipVerisonDoc = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestFlipVerisonDoc());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveFlipVerisonDoc(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchOriginFlipVerisonDoc = (urlDetail: IServiceConfig, _originDocId: any) => (dispatch: Dispatch) => {
    dispatch(requestOriginFlipVerisonDoc());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveOriginFlipVerisonDoc(response.data, _originDocId)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchSectionData = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestMultiCompanySection());
    services.getData(urlDetail, {}, '')
        .then((response: any) => {
            // Important!!! below setTimeout and setInterval is to prevent large multi company doc can't open in IE
            // (before change below code you must test doc_id 863927 in IE)
            if (false && deviceInfoService.isIE()) {
                let _data = response.data;
                const _dataDocumentContentLength = response.data.documentContent.length;
                const _dataSectionLength = response.data.section.length;
                // we have valid key in MultiCompanyMainPage.tsx,So set this value as 1,More large will cause IE long-script warning.
                const _distance = 1;
                let _start = 0;
                let _end = _distance;
                let _partDocumentContent: any = null;
                const _time = 1000;
                let _waitTime = 1000;
                const _multipleTimes = Math.ceil(_dataSectionLength / 50);
                _waitTime = _waitTime * _multipleTimes;
                window.setTimeout(function () {
                    const timeout = window.setInterval(function () {
                        _partDocumentContent = response.data.documentContent.slice(_start, _end);
                        _data = {
                            documentContent: _partDocumentContent,
                            section: response.data.section,
                        };
                        dispatch(receiveMultiCompanySection(_data));
                        if (_end >= _dataDocumentContentLength) {
                            window.clearInterval(timeout);
                        } else {
                            _start = _start + _distance;
                            _end = _end + _distance;
                        }
                    }, _time);
                }, _waitTime);
            } else {
                dispatch(receiveMultiCompanySection(response.data));
            }
        }).catch((error: any) => {
            console.error(error); throw error;
        });
};

const getPlatformId = (urlDetail: any) => {
    const urlEncodedArr = get(urlDetail, "url_parameter[0]", "").split("=");
    const encodedURL = urlEncodedArr[1];    
    const decodedURL = decodeURIComponent(encodedURL);
    const paramsArr = decodedURL.split("?");
    const params = paramsArr[1];
    const searchParams = new URLSearchParams(params);
    return searchParams.get('platformId');
};

export const fetchCopyURL = (urlDetail: IServiceConfig) => async (dispatch: Dispatch) => {
    services.getData(urlDetail, {}, '')
    .then((response: any) => dispatch(receiveCopyURL(response.data)))
    .catch((error: any) => {
        console.error(error); throw error;
    });
}

export const fetchCvrCopyURL = (urlDetail: IServiceConfig, isCopyFigureUrl: boolean = false) => async (dispatch: Dispatch) => {
    isCopyFigureUrl ? dispatch(requestCopyFigureURL()) : dispatch(requestCopyURL());    
    services.getData(urlDetail, {}, '')
        .then((response: any) => {
            const isCvFrameMapping = commonStore.getState().asyncStateReducer.initialData.cvFrameWrapping === 'true';
            const url = get(response, "data.payload.Shortened", "");
            const token = url?.split('/').pop();
            const environment = window.HTML_RENDITION.initialData.environment;
            const newUrl = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + `/cvr/citiresearchui/eppublic/all_research?doc_token=${token}`;
            const newUrlDetail = Object.assign(serviceConfig.GET_CVR_URL, { 'url_parameter': ['url=' + encodeURIComponent(newUrl)] })
            let finalUrl: any = "";
            const fetchFinalUrl = async () => {
            const finalCopyUrl: any = await fetchGenerateUrl(newUrlDetail);
            finalUrl = get(finalCopyUrl, "payload.Shortened", "");
            let shortURL: string = "";
            let platformId = getPlatformId(newUrlDetail);
            if (isEmpty(platformId)) {
                platformId = window.HTML_RENDITION.initialData.platform || '';
            }
            const getGeneratedApi = async () => {
                const generatedUrl: any = await useLazyGenerateCopyUrlQuery(
                    btoa(isCvFrameMapping ? newUrl : url),
                    platformId,
                );
            shortURL = generatedUrl.shortUrl;
            isCopyFigureUrl ? dispatch(receiveCopyFigureURL({copyURL: shortURL})) : dispatch(receiveCopyURL({copyURL: shortURL}));
            };
            getGeneratedApi();
            };
            fetchFinalUrl();
        })
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

const fetchGenerateUrl = async (newUrlDetail: IServiceConfig) => {
    let responseData = {};
        try {
            const response = await services.getData(newUrlDetail, {}, '');
            responseData = get(response, "data", "");
        } catch (error) {
            responseData = {
                data: {}
            };
            console.error(error);
            throw error;
        }
    return responseData;
};

const useLazyGenerateCopyUrlQuery = async (newURL: string, platformId: any) => {
    const isCvFrameMapping = commonStore.getState().asyncStateReducer.initialData.cvFrameWrapping === 'true';
    const urlDetail = serviceConfig.GET_CVR_COPY_URL;
    let responseData: any;
    const properties = [];
    if (isEmpty(platformId)) {
        properties.push(`url=${newURL}&isFromCV=${isCvFrameMapping? true : false}`);
    } else {
        properties.push(`url=${newURL}&platformId=${platformId}&isFromCV=${isCvFrameMapping? true : false}`);
    }
    urlDetail.url_parameter = properties;
    try {
        const response = await services.getData(urlDetail, {}, '');
        responseData = get(response, "data", "");
    } catch (error) {
        responseData = {
            data: {}
        };
        console.error(error);
        throw error;
    }
    return responseData;
};



export const fetchStyleFactors = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestStyleFactorsData());
    services.getData(urlDetail, {}, '')
        .then((response: any) =>dispatch(receiveStyleFactorsData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchRestrictionDetails = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestRestrictionDetailsData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveRestrictionDetailsData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchCatalystWatch = (urlDetail: any) => (dispatch: Dispatch) => {
    dispatch(requestCatalystWatchData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveCatalystWatchData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchCrmUserDetails = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestCrmUserDetailsData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveCrmUserDetailsData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const postMail = (urlDetail: IServiceConfig, data: any) => (dispatch: Dispatch) => {
    dispatch(requestMailData());
    services.getData(urlDetail, data, '')
        .then((response: any) => dispatch(receiveMailData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchFPFigureGallery = (urlDetail: any) => (dispatch: Dispatch) => {
    dispatch(requestFPFigureGalleryData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveFPFigureGalleryData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

let isFigureGalleryGot: boolean = false;

export const fetchFigureGallery = (urlDetail: any) => (dispatch: Dispatch) => {
    if (!isFigureGalleryGot) {
        dispatch(requestFigureGalleryData());
        services.getData(urlDetail, {}, '')
            .then((response: any) => {
                isFigureGalleryGot = true;
                dispatch(receiveFigureGalleryData(response.data));
            })
            .catch((error: any) => {
                dispatch(receiveFigureGalleryData({}));
                console.error(error);
            });
    } else {
        console.log("FigureGallery Got");
    }
};

export const fetchForecast = (urlDetail: IServiceConfig, forecastType: string) => (dispatch: Dispatch) => {
    dispatch(requestForecastData());
    const properties = [];
    const isStandaloneMacroForecast = commonStore.getState().asyncStateReducer.initialData.isStandaloneMacroForecast;
    const isFAVE = isStandaloneMacroForecast ? true : commonStore.getState().asyncStateReducer.initialData.isFAVE;
    const doc_id = isStandaloneMacroForecast ? 0 : commonStore.getState().asyncStateReducer.initialData.doc_id;
    const isJP = isStandaloneMacroForecast ? false : commonStore.getState().asyncStateReducer.docHeaderJsonData.metadata.isJP;
    const DefaultRegionCode = isStandaloneMacroForecast ? '' : commonStore.getState().asyncStateReducer.docHeaderJsonData.metadata.DefaultRegionCode;
    const DefaultCountryCode2 = isStandaloneMacroForecast ? '' : commonStore.getState().asyncStateReducer.docHeaderJsonData.metadata.DefaultCountryCode2;
    properties.push('docId=' + doc_id);
    properties.push('rendition_doc_id=' + doc_id);
    properties.push('type=' + forecastType);
    properties.push('isFAVE=' + isFAVE);
    if (isFAVE){
        if (forecastType == 'ECONOMICLIST'){
            const language =  isJP ? "ja" : "en";
            properties.push('language=' + language);

            let defaultRegion = null;
            let defaultCountryCode = null;
            if (DefaultRegionCode && !isEmpty(DefaultRegionCode)){
                defaultRegion = DefaultRegionCode;
            }
            if (DefaultCountryCode2 && !isEmpty(DefaultCountryCode2)){
                defaultCountryCode = DefaultCountryCode2;
            }
            if (defaultRegion){
                properties.push('region=' + defaultRegion);
            }
            if (defaultCountryCode){
                properties.push('country=' + defaultCountryCode);
            }
        }
    }
    urlDetail.url_parameter = properties;
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveForecastData(response.data, forecastType)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchFinSum = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestFinSumData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveFinSumData(response.data)))
        .catch((error: any) => {
            dispatch(receiveFinSumError());
            console.error(error); throw error;
        });
};

export const fetchRegionBarData = (urlDetail: IServiceConfig, parameters: any) => (dispatch: Dispatch) => {
    dispatch(requestRegionBarData());
    urlDetail.url_parameter = parameters;
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveRegionBarData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchFlagshipPeriodicalData = (urlDetail: IServiceConfig, parameters: any) => (dispatch: Dispatch) => {
    dispatch(requestFlagshipPeriodicalData());
    urlDetail.url_parameter = parameters;
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveFlagshipPeriodicalData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchFocusList = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestFocusList());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveFocusList(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchRelatedPublications = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestRelatedPublications());
    services.getData(urlDetail, {}, '')
        .then((response: any) => {
            dispatch(receiveRelatedPublications(response.data));
        })
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchPriceChart = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestPriceChartData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receivePriceChartData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchReportsToRevisit = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestReportsToRevisitData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveReportsToRevisitData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const getBookMeetingEntitlement = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestBookMeetingData());
    services.getData(urlDetail, {}, '').then((response: any) => dispatch(receiveBookMeetingData(response.data))).catch((error: any) => {
        console.error(error);
        throw error;
    });
};

export const fetchCvMacroTools = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestcvMacroToolsData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receivecvMacroToolsData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchThemes = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestThemesData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveThemesData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchESGTableData = (urlDetail: IServiceConfig, companyInfoUrl: string) => async (dispatch: Dispatch) => {
    dispatch(requestESGTableData());
    const companyInfo = await fetchCompanyInfo(companyInfoUrl);
    if (isEmpty(companyInfo.data?.COVERAGE?.response?.data?.company?.data?.[0]?.industries)) {
        return;
    }
    const companyIndustryData = companyInfo.data?.COVERAGE?.response?.data?.company?.data[0]?.industries[0];
    const companySector = companyIndustryData?.code || '';
    const sectorClassification = companyIndustryData?.classification || '';
    const sectorName = companyIndustryData?.name || '';
    // const companyCode = companyInfo.data?.COVERAGE?.response?.data?.company?.data[0]?.companyCode || '';
    const companyName = companyInfo.data?.COVERAGE?.response?.data?.company?.data[0]?.companyName || '';
    const companyTicker = companyInfo.data?.COVERAGE?.response?.data?.company?.data[0]?.ticker || '';
    commonStore.dispatch(commonStateAction.updateCompanyCoverageAndDerivedFields({sectorName, companyName}));
    const _urlDetail = Object.assign(urlDetail, {
        'url_parameter': [
            `&sector=${companySector}&classification=${sectorClassification}&company=${companyTicker}`,
            'cache=true'
        ]
    });
    services.getData(_urlDetail, {}, '')
        .then((response: any) => dispatch(receiveESGTableData(response.data)))
        .catch((error: any) => {
            console.error(error);
            throw error;
        });
};

const fetchCompanyInfo = async (url: string) => {
    let responseData: any;
    try {
        const response = await services.getData(url, {}, '');
        responseData = {
            data: response.data
        };

    } catch (error) {
        responseData = {
            data: {}
        };
        console.error(error);
        throw error;
    }
    return responseData;
};

export const fetchAnalystInfoById = (urlDetail: IServiceConfig, analystId: string) => (dispatch: Dispatch) => {
    dispatch(requestAnalystInfoById());
    const properties = [];
    properties.push('analystId=' + analystId);
    urlDetail.url_parameter = properties;
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveAnalystInfoById(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchAnalystInfoByName = (urlDetail: IServiceConfig, analystName: string, docId: string) => (dispatch: Dispatch) => {
    dispatch(requestAnalystInfoByName());
    const properties = [];
    properties.push("displayName=" + analystName);
    properties.push("docId=" + docId);
    urlDetail.url_parameter = properties;
    services.getData(urlDetail, {}, "")
        .then((response: any) => dispatch(receiveAnalystInfoByName(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchPollResults = (urlDetail: IServiceConfig, pollId: number) => (dispatch: Dispatch) => {
    dispatch(requestPollResults());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receivePollResults(response.data, pollId)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchRelatedReport = (urlDetail: IServiceConfig, ids: any) => (dispatch: Dispatch) => {
    dispatch(requestRelatedReportData());
    (urlDetail.url_parameter as any).push('related_doc_ids=' + ids);
    services.getData(urlDetail, {}, '')
        .then((response: any) => {
            dispatch(receiveRelatedReportData(response.data));
            setTimeout(() => {
                window.HTML_RENDITION.relatedReportRenderComplete = true;
            }, 500);
        })
        .catch((error: any) => {
            window.HTML_RENDITION.relatedReportRenderComplete = true;
            console.error(error); throw error;
        });
};

 export async function fetchRenditionLink (urlDetail: IServiceConfig, doc_id: any) {
    try{
        urlDetail.url_parameter = ['urlType=RENDITION', 'platformId=' + window.HTML_RENDITION.initialData.platform, 'documentIdentifierText=' + doc_id];
        const response = await services.getData(urlDetail, {}, '');
        return response.data.url;      
    } catch (error){
        throw error;
    }
}

export const fetchGlobalMarketData = (urlDetail: IServiceConfig, documentId: string, type: string) => (dispatch: Dispatch) => {
    dispatch(requestGlobalMarketData());
    const properties = [];
    properties.push("docId=" + documentId);
    properties.push("type=" + type);
    urlDetail.url_parameter = properties;
    services.getData(urlDetail, {}, "")
        .then((response: any) => dispatch(receiveGlobalMarketData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchKeyDataChangeData = (urlDetail: IServiceConfig, documentId: string, type: string) => (dispatch: Dispatch) => {
    dispatch(requestKeyDataChangeData());
    const properties = [];
    properties.push("docId=" + documentId);
    properties.push("type=" + type);
    urlDetail.url_parameter = properties;
    services.getData(urlDetail, {}, "")
        .then((response: any) => dispatch(receiveKeyDataChangeData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchMustReadSectionData = (urlDetail: IServiceConfig, documentId: string, isJP: boolean) => (dispatch: Dispatch) => {
    dispatch(requestMustReadSectionData());
    const properties = [];
    properties.push("docId=" + documentId);
    properties.push("isJp=" + isJP);
    urlDetail.url_parameter = properties;
    services.getData(urlDetail, {}, "")
        .then((response: any) => dispatch(receiveMustReadSectionData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchSessionContextData = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestSessionContextData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveSessionContextData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchPlatformIdData = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestPlatformIdData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receivePlatformIdData(split(response.data, ','))))
        .catch((error: any) => {
            console.error(error); throw error;
        });
};

export const fetchExcludeCopyFigurePlatformIdData = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestExcludeCopyFigurePlatformIdData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveExcludeCopyFigurePlatformIdData(response.data)))
        .catch((error: any) => {
            console.error(error); throw error;
        });
}

export const fetchFileUrlPathData = (urlDetail: IServiceConfig, platformId: string, ticker: string) => async (dispatch: Dispatch) => {
    dispatch(requestFileUrlPath());
    dispatch(updateAnalystModelLoader(true));
    const analystModelData = await fetchAnalystModelData(platformId, ticker);
    if(isEmpty(analystModelData.data)) {
        dispatch(receiveFileUrlPath(""));
        dispatch(updateAnalystModelLoader(false));
    } else {
    const properties = [];
    properties.push('urlType=AUTH_FILE_LINK');
    properties.push(`platformId=${platformId}`);
    properties.push(`documentIdentifierText=model/${get(analystModelData, "data", "")}`);
    urlDetail.url_parameter = properties;
    services.getData(urlDetail, {}, '')
        .then((response: any) => {
            dispatch(receiveFileUrlPath(get(response, 'data.url', "")));
            dispatch(updateAnalystModelLoader(false));
        })
        .catch((error: any) => {
            dispatch(updateAnalystModelLoader(false));
            console.error(error); throw error;
        });
    }
};
export const fetchSendEmailData = (urlDetail: IServiceConfig, postBody: any) => (dispatch: Dispatch) => {
    dispatch(requestSendEmail());
    services.getData(urlDetail, postBody, '')
        .then((response: any) => dispatch(receiveSendEmail(response)))
        .catch((error: any) => {
            dispatch(sendEmailError(error));
            console.error(error); throw error;
        });
};
const fetchAnalystModelData = async (platformId: string, ticker: string) => {
    const urlDetail = serviceConfig.GET_ANALYST_MODEL;
    const companyDataByTicker = await fetchCompanyCoverageByTicker(ticker);
    commonStore.dispatch(receiveCompanyCoverageByTicker(get(companyDataByTicker, "data", {})));
    const needP1Coverage = companyDataByTicker.data?.priority === '2' && companyDataByTicker.data?.shareTimeSeriesData === 'Y';
    const expectedPerformance = await fetchExpectedPerformance(companyDataByTicker.data?.companyCode);
    commonStore.dispatch(receiveExpectedPerformance(get(expectedPerformance, "data", {})));
    let companyDataByCode = {};
    if(needP1Coverage) {
        companyDataByCode = await fetchCompanyCoverageByCode(companyDataByTicker.data?.relatedCompany);
        commonStore.dispatch(receiveCompanyCoverageByCode(get(companyDataByCode, "data", {})));
    }
    const companyCoverage = needP1Coverage ? companyDataByCode : companyDataByTicker;
    const postAnalystModel = {
        pageSize: 1,
        startDate: "2005-01-01T00:00:00Z",
        tickers: [companyCoverage.data?.ticker],
        dataSubmissionIds: [companyCoverage.data?.submissionPublished],
        endDate: moment().format(),
        sortBy: "PublishDate",
        sortDirection: "desc",
        isAnalystModel: true,
    }; 
    let responseData: any;
    const properties = [];
    properties.push(`platformId=${platformId}`);
    urlDetail.url_parameter = properties;
    try {
        const response = await services.getData(urlDetail, postAnalystModel, '');
        
        responseData = {
            data: !isEmpty(response.data.publications) ? get(response, 'data.publications[0].files[0].file', "") : ""
        };

    } catch (error) {
        responseData = {
            data: {}
        };
        commonStore.dispatch(updateAnalystModelLoader(false));
        console.error(error);
        throw error;
    }
    return responseData;
};
const fetchCompanyCoverageByTicker = async (ticker: string) => {
    const urlDetail = serviceConfig.GET_COMPANY_COVERAGE_BY_TICKER;
    let responseData: any;
    const properties = [];
    properties.push(`ticker=${ticker}`);
    urlDetail.url_parameter = properties;
    try {
        const response = await services.getData(urlDetail, {}, '');
        responseData = {
            data: get(response.data, 'response.data.company.data[0]', {})
        };

    } catch (error) {
        responseData = {
            data: {}
        };
        commonStore.dispatch(updateAnalystModelLoader(false));
        console.error(error);
        throw error;
    }
    return responseData;
};
const fetchCompanyCoverageByCode = async (code: string) => {
    const urlDetail = serviceConfig.GET_COMPANY_COVERAGE_BY_TICKER;
    let responseData: any;
    const properties = [];
    properties.push(`code=${code}`);
    urlDetail.url_parameter = properties;
    try {
        const response = await services.getData(urlDetail, {}, '');
        responseData = {
            data: get(response.data, 'response.data.company.data[0]', {})
        };

    } catch (error) {
        responseData = {
            data: {}
        };
        commonStore.dispatch(updateAnalystModelLoader(false));
        console.error(error);
        throw error;
    }
    return responseData;
};
const fetchExpectedPerformance = async (companyCode: string) => {
    let responseData: any;
    const urlDetail = serviceConfig.GET_EXPECTED_PERFORMANCE;
    const properties = [];
    properties.push(`companyCode=${companyCode}`);
    properties.push(`uri=GET_EXPECTED_PERFORMANCE`);
    urlDetail.url_parameter = properties;
    try {
        const response = await services.getData(urlDetail, {}, '');
        responseData = {
            data: get(response.data, 'ExpectedPerformance.0', {})
        };

    } catch (error) {
        responseData = {
            data: {}
        };
        commonStore.dispatch(updateAnalystModelLoader(false));
        console.error(error);
        throw error;
    }
    return responseData;
};
export const fetchUserEntitlements = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    dispatch(requestUserEntitlements());
    services.getData(urlDetail, {}, '')
        .then((response: any) => {
            dispatch(receiveUserEntitlements(get(response, 'data.ENTITLEMENT', '').split(', ')));
        })
        .catch((error: any) => {
            console.error(error); throw error;
        });
};
export const fetchAnalystSubscriptionData = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {       
    dispatch(requestAnalystSubscriptionData());
    services.getData(urlDetail, {}, '')
        .then((response: any) => dispatch(receiveAnalystSubscriptionData(response.data)))
        .catch((error: any) => {
            dispatch(receiveAnalystSubscriptionData({}));
            console.error(error);
        });
    console.log('test: ');
};

export const subscribeAuthorBySoeid = (urlDetail: IServiceConfig, soeid: String) => async(dispatch: Dispatch) => {
    let responseData: any;
    urlDetail.url_parameter = ['author=' + soeid];
    dispatch(requestSubscribeAuthorBySoeid());
    await services.getData(urlDetail, {soeid}, '')
        .then((response: any) => {
                dispatch(receiveSubscribeAuthorBySoeid(response.data));
                responseData = response.data;
            }
            )
        .catch((error: any) => {
            console.error(error); 
            responseData = null;
        }); 
    return responseData;   
};

export const fetchAllCampaignsData = (urlDetail: IServiceConfig) => (dispatch: Dispatch) => {
    let responseData: any;
    dispatch(requestAllCampaignsData());
    services.getData(urlDetail, {}, '')
    .then((response: any) => {
        dispatch(receiveAllCampaignsData(response.data))
        responseData = response.data;
    }
    )
    .catch((error: any) => {
        dispatch(receiveAllCampaignsData({}));
        console.error(error);
        responseData = [];
    });
    return responseData;   
};